module.exports = __webpack_public_path__ + "static/media/Black-rumped-flameback-template.b1e6c106.mp4";